import React from "react";
import Select from "react-select";
import { isEmptyObject, moneyFormatComma } from "../../helpers/function_helper";

export default function Baggage({
  handleChangeHanhLy,
  handleChangeDichVu,
  services,
  passengers,
  indexChieu,
}) {
  return (
    <div className="row">
      {passengers
        .filter((val) => val.type != "Infant")
        .map((p, idx) => {
          let titleOptions =
            services[indexChieu === 0 ? "chieuDi" : "chieuVe"].hanhLy &&
            !isEmptyObject(
              services[indexChieu === 0 ? "chieuDi" : "chieuVe"].hanhLy
            )
              ? services[indexChieu === 0 ? "chieuDi" : "chieuVe"].hanhLy[0] ||
                []
              : [];

          let titleOptionsDichVu =
            services[indexChieu === 0 ? "chieuDi" : "chieuVe"].dichVu &&
            !isEmptyObject(
              services[indexChieu === 0 ? "chieuDi" : "chieuVe"].dichVu
            )
              ? services[indexChieu === 0 ? "chieuDi" : "chieuVe"].dichVu[0] ||
                []
              : [];

          // Group theo "nhom"
          const groupedOptions = titleOptionsDichVu.reduce((acc, item) => {
            const groupName =
              item.mo_ta_nhom && item.mo_ta_nhom !== ""
                ? item.mo_ta_nhom
                : item.nhom;
            if (!acc[groupName]) acc[groupName] = [];
            acc[groupName].push(item);
            return acc;
          }, {});
          return (
            <div
              className="mb-3"
              key={idx}
              style={{ borderBottom: "1px solid #eee", paddingBottom: "20px" }}
            >
              <div className="row">
                <div className="col-lg-3">
                  <h5 className="mt-3 mb-1">{p.name}</h5>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-2">
                    <Select
                      classNamePrefix="form-select"
                      options={titleOptions.map((opt) => ({
                        value: opt.uuid,
                        label: (opt.ten_hien_thi || opt.ten) + " (" + moneyFormatComma(opt.gia_net, false) + ")",
                        ...opt,
                      }))}
                      value={(() => {
                        const uuid =
                          passengers[idx].hanh_ly?.[indexChieu]?.uuid;
                        return (
                          titleOptions
                            .map((opt) => ({
                              value: opt.uuid,
                              label: (opt.ten_hien_thi || opt.ten) + " (" + moneyFormatComma(opt.gia_net, false) + ")",
                              ...opt,
                            }))
                            .find((opt) => opt.value === uuid) || null
                        );
                      })()}
                      onChange={(opt) => {
                        if (titleOptions && opt) {
                          const resHanhLy = titleOptions.find(
                            (o) => o.uuid === opt.value
                          );
                          handleChangeHanhLy(
                            idx,
                            "hanh_ly",
                            resHanhLy,
                            indexChieu
                          );
                        } else {
                          handleChangeHanhLy(idx, "hanh_ly", null, indexChieu);
                        }
                      }}
                      placeholder="Chọn hành lý"
                      isClearable
                    />
                  </div>
                  {Object.entries(groupedOptions).map(([groupName, items]) => (
                    <div
                      key={groupName}
                      className="form-group mb-2"
                    >
                      <Select
                        classNamePrefix="form-select"
                        options={items.map((opt) => ({
                          value: opt.uuid,
                          label: (opt.ten_hien_thi || opt.ten) + " (" + moneyFormatComma(opt.gia_net, false) + ")",
                          ...opt,
                        }))}
                        value={(() => {
                          const uuid =
                            passengers[idx].dich_vu?.[indexChieu]?.[groupName]
                              ?.uuid;
                          return (
                            items
                              .map((opt) => ({
                                value: opt.uuid,
                                label: (opt.ten_hien_thi || opt.ten) + " (" + moneyFormatComma(opt.gia_net, false) + ")",
                                ...opt,
                              }))
                              .find((opt) => opt.value === uuid) || null
                          );
                        })()}
                        onChange={(opt) => {
                          if (items && opt) {
                            var resDichVu = items.find(
                              (o) => o.uuid === opt.value
                            );
                            handleChangeDichVu(
                              idx,
                              groupName,
                              resDichVu,
                              indexChieu
                            );
                          } else {
                            handleChangeDichVu(
                              idx,
                              groupName,
                              null,
                              indexChieu
                            );
                          }
                        }}
                        placeholder={`Chọn dịch vụ ${groupName}`}
                        isClearable
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}
